import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
import Airport from '@/views/Airport';
import Terminal from '@/views/Terminal';
import Detail from '@/views/Detail';
import Payment from '@/views/Payment';
import Success from '@/views/Success';
import Error from '@/views/Error';
import MessageEn from '@/views/Message.en';
import MessageJa from '@/views/Message.ja';
import Message from '@/views/Message';

Vue.use(Router);

export default new Router({
	mode: 'hash',
	// base: '/html/',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/airport',
			name: 'Airport',
			component: Airport
		},
		{
			path: '/terminal',
			name: 'Terminal',
			component: Terminal
		},
		{
			path: '/detail',
			name: 'Detail',
			component: Detail
		},
		{
			path: '/payment',
			name: 'Payment',
			component: Payment
		},
		{
			path: '/error',
			name: 'Error',
			component: Error
		},
		{
			path: '/success',
			name: 'Success',
			component: Success
		},
		{
			path: '/message/en/:dragonCode',
			name: 'MessageEn',
			component: MessageEn
		},
		{
			path: '/message/ja/:dragonCode',
			name: 'MessageJa',
			component: MessageJa
		},
		{
			path: '/message/:dragonCode',
			name: 'Message',
			component: Message
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js